export default "__VITE_ASSET__11f14704__"